const BOOLEAN_FIELDS = [
  "streamEnabled",
  "scrollsEnabled",
  "outboundClicksEnabled",
  "siteSearchEnabled",
  "videoEngagementEnabled",
  "fileDownloadsEnabled",
  "pageChangesEnabled",
  "formInteractionsEnabled",
]

const DEFAULT_SEARCH_QUERY = "q,s,search,query,keyword"

const parseBoolean = (value) => {
  if (typeof value === "boolean") return value
  if (typeof value === "string") {
    const trimmed = value.trim().toLowerCase()
    if (trimmed === "true") return true
    if (trimmed === "false") return false
  }
  return Boolean(value)
}

const normalizeQueryList = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => (typeof item === "string" ? item.trim() : ""))
      .filter(Boolean)
      .join(",")
  }
  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item.length > 0)
      .join(",")
  }
  return DEFAULT_SEARCH_QUERY
}

export const DEFAULT_ENHANCED_MEASUREMENT_SETTINGS = Object.freeze({
  streamEnabled: true,
  scrollsEnabled: true,
  outboundClicksEnabled: true,
  siteSearchEnabled: true,
  videoEngagementEnabled: true,
  fileDownloadsEnabled: true,
  pageChangesEnabled: true,
  formInteractionsEnabled: true,
  searchQueryParameter: DEFAULT_SEARCH_QUERY,
})

export const normalizeEnhancedMeasurementSettings = (
  value,
  { includeDefaults = true } = {}
) => {
  const base = includeDefaults
    ? { ...DEFAULT_ENHANCED_MEASUREMENT_SETTINGS }
    : {}

  if (!value || typeof value !== "object") {
    return includeDefaults ? base : null
  }

  const normalized = { ...base }
  let hasValue = false

  for (const key of BOOLEAN_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      normalized[key] = parseBoolean(value[key])
      hasValue = true
    } else if (!includeDefaults) {
      normalized[key] = DEFAULT_ENHANCED_MEASUREMENT_SETTINGS[key]
    }
  }

  if (Object.prototype.hasOwnProperty.call(value, "searchQueryParameter")) {
    normalized.searchQueryParameter = normalizeQueryList(
      value.searchQueryParameter
    )
    hasValue = true
  } else if (!includeDefaults) {
    normalized.searchQueryParameter =
      DEFAULT_ENHANCED_MEASUREMENT_SETTINGS.searchQueryParameter
  }

  return hasValue || includeDefaults ? normalized : null
}

export const ensureEnhancedMeasurementSettings = (value) =>
  normalizeEnhancedMeasurementSettings(value, { includeDefaults: true })

